import '../fonts/FoundryGridnik-Bold.woff2';
import '../fonts/FoundryGridnik-Regular.woff2';
import '../fonts/ProximaNova-Bold.woff2';
import '../fonts/ProximaNova-Regular.woff2';
import '../fonts/ProximaNova-SemiBold.woff2';

import '../img/binoculars.svg';
import '../img/button.svg';
import '../img/envelope.svg';
import '../img/horseshoe.svg';
import '../img/pen.svg';
import '../img/star.svg';
import '../img/ticket.svg';

import '../img/thanks-for-spreading-the-word.jpg';
import '../img/thanks-gallery-2.jpg';
import '../img/thanks-gallery-3.jpg';
import '../img/thanks-gallery-4.jpg';
import '../img/championsday23_georginapreston-22526.jpg';
import '../img/alert-circle.png';
import '../img/referral-header.jpg';
import '../img/logo-white.png';
import '../img/logo-blue.png';

import '../sass/main.scss';

import './common/anchor.js';
import './common/focus.js';
import './common/css-variables.js';

import './layouts/cookies-notice.js';

import './common/on-screen.js';

import { initModals } from './common/modals.js';

(() => {
    initModals();
})();
